import React from "react";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { Container, Jumbotron, Col, Row, Button } from "reactstrap";

function Home(props) {
  const isLoggedIn = props.CustomerStore.currentCustomer;

  return (
    <Jumbotron className="bg-transparent">
      <Container className="home-container">
        <Row>
          <Col xs="12" md={{ size: 8, offset: 2 }}>
            <h1>{props.CommonStore.appName}</h1>
            {isLoggedIn ? (
              <p>Click next to open the purchasing form.</p>
            ) : (
              <>
                <p>
                  To purchase chukkerCoin, please complete the form and secure your allocation.
                </p>
                <p>
                  Click the button below to start the process.
                </p>
              </>
            )}
            <Button
              tag={Link}
              to={isLoggedIn ? "/subscription" : "/login"}
              color="primary"
              size="lg"
              className="mt-3"
            >
              {isLoggedIn ? "Next" : "Buy Now"}
            </Button>
          </Col>
        </Row>
      </Container>
    </Jumbotron>
  );
}

export default inject("CommonStore", "CustomerStore")(observer(Home));
